import styled from 'styled-components';

export const StyledPagination = styled.div`
  margin-top: 24px;

  .pagination {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 10px;

    &.absolute-bottom {
      position: absolute;
      bottom: 50px;
      right: 10px;
    }

    &-select {
      display: flex;
      align-items: center;

      &-option {
        border-radius: 4px;
        border: 1px solid rgb(218, 218, 218);
        margin-right: 0px !important;
        margin-left: 12px;
        padding: 0;

        .MuiSelect-select {
          padding: 6px 30px 6px 16px;
        }
      }
    }
  }

  .MuiTablePagination-input {
    margin-left: 12px;
    padding: 0;

    .MuiTablePagination-select {
      padding: 6px 30px 6px 16px;
    }
  }

  .MuiPaginationItem-text.Mui-selected {
    height: 32px;
    font-size: 14px;
    font-weight: 500;
    color: var(--color-white);
    background-color: var(--color-primary-blue);
  }
`;
